export default __webpack_public_path__ + "assets/images/f9ffcab034edd129ce3629f1eb192952.svg";